const name = 'user-tasks';
const schedules = 'schedules';

export const GET_USER_TASKS_SORTED_LIST_REQUEST = `${name}/GET_USER_TASKS_SORTED_LIST_REQUEST`;
export const GET_USER_TASKS_SORTED_LIST_SUCCESS = `${name}/GET_USER_TASKS_SORTED_LIST_SUCCESS`;
export const GET_USER_TASKS_SORTED_LIST_FAILURE = `${name}/GET_USER_TASKS_SORTED_LIST_FAILURE`;

export const ADD_USER_TASK_REQUEST = `${name}/ADD_USER_TASK_REQUEST`;
export const ADD_USER_TASK_SUCCESS = `${name}/ADD_USER_TASK_SUCCESS`;
export const ADD_USER_TASK_FAILURE = `${name}/ADD_USER_TASK_FAILURE`;

export const UPDATE_USER_TASK_REQUEST = `${name}/UPDATE_USER_TASK_REQUEST`;
export const UPDATE_USER_TASK_SUCCESS = `${name}/UPDATE_USER_TASK_SUCCESS`;
export const UPDATE_USER_TASK_FAILURE = `${name}/UPDATE_USER_TASK_FAILURE`;

export const DELETE_USER_TASK_REQUEST = `${name}/DELETE_USER_TASK_REQUEST`;
export const DELETE_USER_TASK_SUCCESS = `${name}/DELETE_USER_TASK_SUCCESS`;
export const DELETE_USER_TASK_FAILURE = `${name}/DELETE_USER_TASK_FAILURE`;

export const GET_ORDER_TASKS_REQUEST = `${name}/GET_ORDER_TASKS_REQUEST`;
export const GET_ORDER_TASKS_SUCCESS = `${name}/GET_ORDER_TASKS_SUCCESS`;
export const GET_ORDER_TASKS_FAILURE = `${name}/GET_ORDER_TASKS_FAILURE`;

export const GET_SCHEDULE_REQUEST = `${schedules}/GET_SCHEDULE_REQUEST`;
export const GET_SCHEDULE_SUCCESS = `${schedules}/GET_SCHEDULE_SUCCESS`;
export const GET_SCHEDULE_FAILURE = `${schedules}/GET_SCHEDULE_FAILURE`;

export const CHANGE_STATUS_REQUEST = `${name}/CHANGE_STATUS_REQUEST`;
export const CHANGE_STATUS_SUCCESS = `${name}/CHANGE_STATUS_SUCCESS`;
export const CHANGE_STATUS_FAILURE = `${name}/CHANGE_STATUS_FAILURE`;

export default name;
